import { PurchasePriceQuestion } from '@hb/domain';
import { PurchasePriceStoreService } from '@hb/modules/property/purchase-price/purchase-price-store.service';
import { PurchasePriceAmountComponent } from '@hb/modules/property/purchase-price/purchase-price-amount/purchase-price-amount.component';
import { PreviousButtonComponent } from '@hb/modules/global/button';

import { Subscription } from 'rxjs';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ApContentModule } from '@ap/content';
import { ApRadioModule } from '@ap/radio';

@Component({
    selector: 'purchase-price',
    templateUrl: './purchase-price.component.html',
    standalone: true,
    imports: [ApContentModule, FormsModule, ReactiveFormsModule, ApRadioModule, PreviousButtonComponent, PurchasePriceAmountComponent]
})
export class PurchasePriceComponent implements OnInit, OnDestroy {
    protected readonly store = inject(PurchasePriceStoreService);

    private activeQuestion: PurchasePriceQuestion;
    private activeQuestionSubscription: Subscription;

    ngOnInit(): void {
        this.activeQuestionSubscription = this.store
            .getActiveQuestion()
            .subscribe((activeQuestion) => (this.activeQuestion = activeQuestion));
    }

    ngOnDestroy(): void {
        this.activeQuestionSubscription.unsubscribe();
    }

    previousQuestion(): void {
        this.store.backQuestion();
    }

    showPurchasePrice(): boolean {
        return (
            this.activeQuestion === PurchasePriceQuestion.PURCHASE_PRICE_AMOUNT ||
            (this.store.isActiveQuestion(PurchasePriceQuestion.PURCHASE_PRICE_AMOUNT) && this.store.isSummary)
        );
    }
}
